import React, { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import DaysBanner from "../../components/daysBanner/daysBanner.comp";
import { UserContext } from "../../contexts/user.context";
import "./nextWeek.style.scss"
import {
    getCurrentAcceptedChallengesForUser,
    updateAcceptedChallenge
} from "../../utils/firebase/firebase.utils";
import Navbar from "../../components/navbar/navbar.comp";
import WeekEvent from "../../components/weekEvent/weekEvent.comp";
import DateContext from '../../contexts/dates.context';
import Button from "../../components/button/button.comp";
import { initialAcceptedChallenges } from "../../utils/initialObjects.comp";
import { formatDateShort, getDayOfWeek } from "../../utils/dating.utils";

const NextWeek = () => {


    //INPUTS
    const { userID } = useContext(UserContext);
    const navigate = useNavigate();
    const { nextWeekDates } = useContext(DateContext);


    //[1] GET CHALLENGES
    const [challenges, setChallenges] = useState(initialAcceptedChallenges);
    const [loadedBoolean, setLoadedBoolean] = useState(false)
    const [anchor, setAnchor] = useState(null);
    useEffect(() => {
        const timer = setTimeout(async () => {
            const loadedChallenges = await getCurrentAcceptedChallengesForUser(userID);
            setChallenges(loadedChallenges);
            setAnchor(JSON.parse(JSON.stringify(loadedChallenges))); // Deep copy of loadedChallenges
            setLoadedBoolean(true)
            checkNextWeekEvents(loadedChallenges, nextWeekDates);

        }, 1000);

        return () => clearTimeout(timer);
    }, []);


    //[2] CHECKING DATES
    const [nextWeekEventsBoolean, setNextWeekEventsBoolean] = useState(false)
    const checkNextWeekEvents = (challenges, nextWeekDates) => {
        // Iterate through each challenge
        for (let challenge of challenges) {
            // Iterate through each event in the challenge's events array
            for (let event of challenge.events) {
                // Check if the event is included in the nextWeekDates array
                if (nextWeekDates.includes(event)) {
                    console.log("Next Week Dates: ", true)
                    setNextWeekEventsBoolean(true)
                    return true; // Return true if a match is found
                }
            }
        }
        console.log("Next Week Dates: ", false)
        setNextWeekEventsBoolean(false)
        return false; // Return false if no matches are found
    };


    //[2] DAY CLICKED
    const handleDayClick = (buttonIndex, challengeIndex, dateIndex, boolean) => {

        if (boolean === false) {
            const date = nextWeekDates[buttonIndex];

            console.log(
                "Button Index: ", buttonIndex,
                "Challenge: ", challenges[challengeIndex],
                "Date (now): ", challenges[challengeIndex].events[dateIndex],
                "Date (to set): ", date
            )

            // Create a deep copy of the specific challenge to avoid mutating the state directly
            const thisChallenge = { ...challenges[challengeIndex] };
            thisChallenge.events = [...thisChallenge.events];

            thisChallenge.events[dateIndex] = date;

            setChallenges(prevChallenges => {
                const updatedChallenges = [...prevChallenges];
                updatedChallenges[challengeIndex] = thisChallenge;
                return updatedChallenges;
            });
            setChangesFlag(true)
        }
    }


    //[2] POP UP
    const handleCloseSavePopUp = () => {
        setSavePopUp(false)
    }
    const handleClosePopUp = () => {
        setSavePopUp(false)
        setChangesFlag(false)
        setSaving(false)
        setSaved(false)
    }


    //[3] POST SAVE CHANGES TO FIREBASE
    const [changesFlag, setChangesFlag] = useState(false)
    const [savePopUp, setSavePopUp] = useState(false)
    const [saving, setSaving] = useState(false)
    const [saved, setSaved] = useState(false)
    const handleSave = () => setSavePopUp(true);
    const handleSaveToFirebase = async () => {
        try {
            for (const challenge of challenges) {
                setSaving(true)
                await updateAcceptedChallenge(challenge.id, challenge);
            }
            console.log('All challenges updated successfully.');
            setSaving(false)
            setChangesFlag(false)
            setSaved(true)
        } catch (error) {
            console.error('Error updating challenges:', error);
        }
        setAnchor(JSON.parse(JSON.stringify(challenges))); // Deep copy of loadedChallenges
    }
    const handleCancel = () => {
        setChangesFlag(false)
        console.log(changesFlag)
        setChallenges(anchor)
    }


    return (
        <div>
            <Navbar option={3} />

            <DaysBanner dayFlag={false} nextWeek={true} />

            {/* Buttons */}
            <div className="section frame tight">
                <div
                    style={{ display: 'flex', justifyContent: 'flex-end' }}
                    className="button-wrapper"
                >
                    {
                        !changesFlag || savePopUp ? (
                            <div className="button-wrapper">
                                <Button text={'Cancel'} option={'inactive'} />
                                <Button text={'Save'} option={'inactive'} />
                            </div>
                        ) : (
                            <div className="button-wrapper">
                                <Button text={'Cancel'} option={'button-linked-text'} onClick={handleCancel} />
                                <Button text={'Save'} option={'green'} onClick={handleSave} />
                            </div>
                        )
                    }
                </div>
            </div>

            {/* Loading Circle */}
            {!loadedBoolean && (
                <div className="loading-circle"></div>
            )}

            {/* Challenges */}
            {loadedBoolean && (
                <div className="section frame tight">
                    {challenges.map((challengeObject, challengeIndex) => {

                        const eventsArray = challengeObject.events;
                        // Check if there are any events for nextWeekDates
                        const hasEventsForNextWeek = eventsArray.some((event, index) => {
                            // Check if the event is within the next week dates
                            return nextWeekDates.includes(event);
                        });

                        if (hasEventsForNextWeek) {
                            return (
                                <div className="next-week-challenge" key={challengeIndex}>
                                    <div className="next-week-challenge-title">
                                        <div className="next-week-challenge-image"
                                            style={{
                                                backgroundImage: `url(${challengeObject.imageURL})`,
                                                backgroundSize: 'cover',
                                                backgroundPosition: 'center',
                                                backgroundRepeat: 'no-repeat',
                                                // height: '80px',
                                                // width: '80px',
                                                // borderRadius: '12px'
                                            }}
                                        >
                                        </div>
                                        <h2 style={{ color: 'var(--fontlightblack1)', cursor: 'default' }}>
                                            {challengeObject.title}
                                        </h2>
                                    </div>
                                    {eventsArray.map((row, index) => {
                                        if (nextWeekDates.includes(row)) {

                                            const eventNumber = eventsArray[index - 3];
                                            const date = eventsArray[index];
                                            const boolean = eventsArray[index + 1];

                                            const dateIndex = index; // index of date item in eventsArray

                                            const dayOfWeek = getDayOfWeek(date);

                                            const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
                                            const IndexOfDay = days.indexOf(dayOfWeek);

                                            const dayString = getDayOfWeek(date);
                                            const dateString = formatDateShort(date);

                                            return (
                                                <WeekEvent
                                                    eventNumber={eventNumber}
                                                    eventsTotal={challengeObject.eventsTotal}
                                                    eventTime={challengeObject.eventTime}
                                                    eventTitle={challengeObject.eventTitle}
                                                    challengeIndex={challengeIndex}
                                                    handleDayClick={handleDayClick}
                                                    boolean={boolean}
                                                    indexOfDay={IndexOfDay}
                                                    dateIndex={dateIndex}
                                                    dayString={dayString}
                                                    dateString={dateString}
                                                // toggleDone={toggleDone}
                                                />
                                            )
                                        }
                                    })}
                                </div>
                            )
                        }

                        // Render nothing if there are no events for the next week
                        return null;
                    })}
                </div>
            )}

            {/* No Events */}
            {loadedBoolean && (
                !nextWeekEventsBoolean && (
                    <p>No events scheduled for next week</p>
                )
            )}

            {/* Pop Up Save Changes */}
            {savePopUp && (
                <div className="save-pop-up-container">
                    <div className="save-pop-up">
                        <div className="save-pop-up-header">
                            <div className="title">
                                <div
                                    className="close pointer"
                                    style={{
                                        backgroundImage: `url(${'https://logowik.com/content/uploads/images/close1437.jpg'})`,
                                        backgroundSize: 'cover',
                                        backgroundPosition: 'center',
                                        backgroundRepeat: 'no-repeat'
                                    }}
                                    onClick={handleCloseSavePopUp}>
                                </div>
                            </div>
                        </div>
                        {saving ? (
                            <div style={{ display: 'flex', alignItems: 'center' }} className="save-pop-up-scroll-view ">
                                <p style={{ fontSize: 'large', textAlign: "center" }} >Saving...</p>
                                <div className="this-week-loading-circle"></div>
                            </div>
                        ) : (
                            saved ? (
                                <div style={{ display: 'flex', alignItems: 'center' }} className="save-pop-up-scroll-view ">
                                    <p style={{ fontSize: 'large', textAlign: "center" }} >Your changes are saved!</p>
                                    <Button text={'Close'} option={'yellow'} onClick={handleClosePopUp} />
                                </div>
                            ) : (
                                <div style={{ display: 'flex', alignItems: 'center' }} className="save-pop-up-scroll-view ">
                                    <p style={{ fontSize: 'large', textAlign: "center" }} >Are you sure you want to save changes?</p>
                                    <Button text={'Save'} option={'green'} onClick={handleSaveToFirebase} />
                                </div>
                            )
                        )}
                    </div>
                </div>
            )}

            <div className="footer-margin">
            </div>
        </div>
    );
};

export default NextWeek;